import apiFetch from '../apiFetch'

export default function (token, taskId) {
  const queryParamsArray = [
    `styleTaskId=${taskId}`
  ]
  const queryParams = queryParamsArray.reduce(
    (result, query, idx) => result + (query ? (result ? `&${query}` : `?${query}`) : '')
    , ''
  )
  return apiFetch({ endPoint: `StyleTask/Delete${queryParams}`, method: 'DELETE', body: null, token: token })
}
